import { useState } from "react";
import { BiLogoFacebook, BiLogoLinkedin, BiLogoPinterestAlt, BiLogoTwitter } from "react-icons/bi";
import { Link, NavLink } from "react-router-dom";
import { useLogoutUserQuery } from "../redux/services/auth/logoutAPI";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const socials = [
  { icon: BiLogoTwitter, label: "Twitter" },
  { icon: BiLogoLinkedin, label: "LinkedIn" },
  { icon: BiLogoFacebook, label: "Facebook" },
  { icon: BiLogoPinterestAlt, label: "Pinterest" },
];

const TopHeader = ({ user, handleUserChange }) => {
  const { refetch } = useLogoutUserQuery();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const logoutHandle = async () => {
    refetch();
    localStorage.removeItem("user");
    handleUserChange?.(null);
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
    Toast.fire({
      icon: "success",
      title: "You have logged out successfully",
    });
    navigate("/");
  };

  return (
    <div className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-slate-950/95 text-white backdrop-blur-xl">
      <div className="section-shell flex h-14 items-center justify-between gap-4">
        <div className="flex min-w-0 items-center gap-3 text-sm">
          {user ? (
            <div className="relative">
              <button
                type="button"
                onClick={() => setMenuOpen(!menuOpen)}
                className="inline-flex items-center gap-2 rounded-full px-3 py-1.5 font-semibold text-slate-100 transition hover:bg-white/10 focus:outline-none focus:ring-4 focus:ring-white/10"
                aria-expanded={menuOpen}
              >
                <span className="h-2.5 w-2.5 rounded-full bg-emerald-400" />
                <span className="max-w-[12rem] truncate">{user?.name} {user?.family}</span>
              </button>

              {menuOpen && (
                <div className="absolute left-0 top-full mt-2 w-48 overflow-hidden rounded-2xl border border-white/10 bg-slate-900 py-2 shadow-2xl">
                  <NavLink to="/dashboard" onClick={() => setMenuOpen(false)} className="block px-4 py-2.5 text-sm font-semibold text-slate-200 transition hover:bg-white/10">Dashboard</NavLink>
                  <NavLink to="/cart" onClick={() => setMenuOpen(false)} className="block px-4 py-2.5 text-sm font-semibold text-slate-200 transition hover:bg-white/10">Cart</NavLink>
                  <NavLink to="/favorites" onClick={() => setMenuOpen(false)} className="block px-4 py-2.5 text-sm font-semibold text-slate-200 transition hover:bg-white/10">Favorites</NavLink>
                  <button type="button" onClick={logoutHandle} className="block w-full px-4 py-2.5 text-left text-sm font-semibold text-coral transition hover:bg-white/10">Log Out</button>
                </div>
              )}
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <Link to="/register" className="rounded-full px-3 py-1.5 text-sm font-bold text-slate-200 transition hover:bg-white/10">Register</Link>
              <Link to="/login" className="rounded-full bg-white px-3 py-1.5 text-sm font-bold text-slate-950 transition hover:bg-slate-100">Login</Link>
            </div>
          )}
        </div>

        <div className="flex items-center gap-1 text-slate-300" aria-label="Social links">
          {socials.map((item) => {
            const Icon = item.icon;
            return (
              <a key={item.label} href="#!" aria-label={item.label} className="grid h-8 w-8 place-items-center rounded-full transition hover:bg-white/10 hover:text-white">
                <Icon className="h-4 w-4" />
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
